export const shows = [
  {
    date: 'February 20, 2026',
    venue: 'Rambling House',
    city: 'Columbus, OH',
    title: 'Direct Support',
    ticketLink: 'https://www.bandsintown.com/e/107640115',
  },
  {
    date: 'February 28, 2026',
    venue: 'Moshmellow',
    city: 'St. Louis, MO',
    title: 'Headlining',
    status: 'SOLD OUT',
  },
  {
    date: 'March 14, 2026',
    venue: 'Livewire Lounge',
    city: 'Chicago, IL',
    title: 'Headlining',
  },
  {
    date: 'March 21, 2026',
    venue: 'SONARFEST',
    city: 'Kent, OH',
    title: 'Direct Support',
    ticketLink:
      'https://www.purplepass.com/events/343557-sonarfest-oh-2026-mar-21st',
  },
  {
    date: 'April 25, 2025',
    venue: 'Summit Music Hall',
    city: 'Columbus, OH',
    title: 'Toadfest',
    ticketLink:
      'https://www.eventbrite.com/e/toadfest-2025-ft-cane-toads-koda-loconti-mamadog-many-more-tickets-1291966589849',
  },
  {
    date: 'April 26, 2025',
    venue: 'The Woods',
    city: 'Oxford, OH',
  },
  {
    date: 'May 3, 2025',
    venue: 'Library Bar',
    city: 'Columbus, OH',
  },
  {
    date: 'August 22, 2025',
    venue: 'Frostys',
    city: 'Put-in-Bay, OH',
    notes: 'Acoustic set, Time TBD',
  },
  {
    date: 'August 23, 2025',
    venue: 'Frostys',
    city: 'Put-in-Bay, OH',
    notes: 'Full band, Time TBD',
  },
  {
    date: 'August 28, 2025',
    venue: 'A&R Music Bar',
    city: 'Columbus, OH',
    title: 'Opening for Brent Cobb',
    notes: 'Doors at 7:00. DM us for paper tickets!',
    ticketLink:
      'https://www.axs.com/events/952238/brent-cobb-tickets?skin=armusicbar&_ga=2.78015442.738452507.1753964704-103789931.1753964704',
  },
  {
    date: 'August 29, 2025',
    venue: 'The Library Bar OSU',
    city: 'Columbus, OH',
    notes: '7:30-8:30 (Audley) / 9:00-11:00 (KODA)',
  },
]
